import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
import Title from '../../../atoms/Title';
import LinkButton from '../../../buttons/LinkButton';
import * as styles from './companyProfileDescription.linaria';
function CompanyProfileDescription({ company, className, }) {
    var _a;
    const [clamped, setClamped] = useState(true);
    const [showButton, setShowButton] = useState(true);
    const containerRef = useRef(null);
    const handleClick = () => setClamped(!clamped);
    const checkShouldCollapse = () => {
        const { clientHeight, scrollHeight } = containerRef.current;
        if (scrollHeight > clientHeight) {
            setShowButton(true);
        }
        else {
            setShowButton(false);
        }
    };
    const debouncedCheck = debounce(checkShouldCollapse, 50);
    useEffect(() => {
        checkShouldCollapse();
        window.addEventListener('resize', debouncedCheck);
        return () => {
            window.removeEventListener('resize', debouncedCheck);
        };
    }, []);
    return (<div className={classNames([styles.descriptionWrapper, className])}>
      <Title size="small">Hvem er vi?</Title>
      <div ref={containerRef} className={classNames(['company-description', clamped && 'clamp'])}>
        {(_a = company.companyDescription) !== null && _a !== void 0 ? _a : 'Mangler informasjon'}
      </div>
      {showButton && (<LinkButton icon={clamped ? 'Down' : 'Up'} iconSize="small" onClick={handleClick}>
          {clamped ? 'Les mer' : 'Les mindre'}
        </LinkButton>)}
    </div>);
}
CompanyProfileDescription.defaultProps = {
    className: null,
};
export default CompanyProfileDescription;
